module.exports = __webpack_public_path__ + "img/tweet5.2ec29a53.png";